<template>
    <div>
        <div style="display: flex; flex-direction: row">
            <template v-if="multiple">
                <v-autocomplete
                    :readonly="readonly"
                    @update:search-input="SearchOrden"
                    v-model="selectedOrders"
                    :items="ordenes"
                    item-text="nro_orden"
                    item-value="id"
                    :label="label"
                    :outlined="outlined"
                    :dense="dense"
                    :rules="rules"
                    multiple
                    chips
                    deletable-chips
                    small-chips
                    clearable
                >
                    <template v-slot:append-item>
                        <div v-intersect="endIntersect" />
                    </template>
                    <template v-slot:selection="data">
                        <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click:close="remove(data.item)"
                        >
                            <router-link
                                :to="`guardar-orden?id=${data.item.id}`"
                                target="_blank"
                            >
                                {{ data.item.nro_orden }}</router-link
                            >
                        </v-chip>
                    </template>
                </v-autocomplete>
            </template>
            <template v-else>
                <v-autocomplete
                    :readonly="readonly"
                    @update:search-input="SearchOrden"
                    v-model="id_orden"
                    :items="ordenes"
                    item-text="nro_orden"
                    item-value="id"
                    :label="label"
                    :outlined="outlined"
                    :rules="rules"
                    :dense="dense"
                >
                    <template v-slot:append-item>
                        <div v-intersect="endIntersect" />
                    </template>
                    <template v-slot:selection="data">
                        <v-chip
                            small
                            v-bind="data.attrs"
                            :input-value="data.selected"
                        >
                            <router-link
                                :to="`guardar-orden?id=${data.item.id}`"
                                target="_blank"
                            >
                                {{ data.item.nro_orden }}</router-link
                            >
                        </v-chip>
                    </template>
                </v-autocomplete>
            </template>
        </div>
    </div>
</template>
<script>
import { debounce } from "../../helpers";

export default {
    props: [
        "value",
        "extra",
        "label",
        "item-text",
        "enabled",
        "outlined",
        "rules",
        "multiple",
        "readonly",
        "dense",
        "idCliente",
    ],
    data() {
        return {
            creado: null,
            id_orden: null,
            orden: {},
            dialog: false,
            users: [],
            update: false,
            selectedOrders: [],
            ordenesLocal: [],
        };
    },
    watch: {
        value(val) {
            if (this.multiple) {
                if (typeof val == "number") {
                    this.selectedOrders = [val];
                } else {
                    this.selectedOrders = val || [];
                }
            } else {
                this.id_orden = val;
            }
        },
        id_orden(val) {
            this.$emit("input", val);
        },
        selectedOrders(newOrders) {
            this.$emit("input", newOrders);
        },
        idCliente: {
            deep: true,
            handler() {
                if (this.hasClienteFilter) {
                    this.loadOrdenes();
                } else {
                    this.ordenesLocal = [];
                    this.$store.dispatch("getOrdenes", this);
                }
            },
        },
    },
    methods: {
        buildOrdenesParams(busqueda) {
            const params = {
                amount: this.hasClienteFilter ? -1 : 15,
                page: 1,
            };
            if (busqueda) {
                params.busqueda = busqueda;
            }
            if (this.hasClienteFilter) {
                params.id_cliente = this.clienteIds;
            }
            return params;
        },
        loadOrdenes(busqueda = "") {
            axios
                .get(`api/get-ordenes`, {
                    params: this.buildOrdenesParams(busqueda),
                })
                .then((res) => {
                    this.ordenesLocal = res.data.data || [];
                    if (this.multiple && this.selectedOrders?.length) {
                        const valid = new Set(
                            this.ordenesLocal.map((o) => o.id)
                        );
                        const filtered = this.selectedOrders.filter((id) =>
                            valid.has(id)
                        );
                        if (filtered.length !== this.selectedOrders.length) {
                            this.selectedOrders = filtered;
                        }
                    }
                })
                .catch(() => {});
        },
        SearchOrden: debounce(function (val) {
            if (this.hasClienteFilter || this.useLocalOrdenes) {
                this.loadOrdenes(val);
            } else {
                this.$store.dispatch("searchOrden", val);
            }
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting && !this.hasClienteFilter) {
                this.$store.dispatch("getOrdenesNext", this);
            }
        },
        remove(item) {
            const index = this.selectedOrders.findIndex(
                (element) => element == item.id
            );
            if (index >= 0) this.selectedOrders.splice(index, 1);
        },
    },
    mounted() {
        if (this.hasClienteFilter) {
            this.loadOrdenes();
        } else {
            this.$store.dispatch("getOrdenes", this);
        }
        if (this.value != null) {
            if (this.multiple) {
                this.selectedOrders = this.value;
            } else {
                this.id_orden = this.value;
            }
        }
    },
    computed: {
        clienteIds() {
            if (Array.isArray(this.idCliente)) {
                return this.idCliente.filter(
                    (id) => id !== null && id !== "" && id !== undefined
                );
            }
            if (this.idCliente != null && this.idCliente !== "") {
                return [this.idCliente];
            }
            return [];
        },
        hasClienteFilter() {
            return this.clienteIds.length > 0;
        },
        useLocalOrdenes() {
            return this.hasClienteFilter || this.ordenesLocal.length > 0;
        },
        ordenes() {
            let ordenes_temp = this.hasClienteFilter
                ? [...this.ordenesLocal]
                : [...(this.$store.getters.getordenes || [])];

            if (!this.hasClienteFilter && this.ordenesLocal.length) {
                // merge unique from local search results if any
                const ids = new Set(ordenes_temp.map((o) => o.id));
                this.ordenesLocal.forEach((o) => {
                    if (!ids.has(o.id)) ordenes_temp.push(o);
                });
            }

            if (this.extra != null) {
                if (this.multiple) {
                    ordenes_temp = ordenes_temp.concat(
                        this.extra.map((item) => {
                            return {
                                id: item.id_orden,
                                nro_orden: item?.orden?.nro_orden,
                            };
                        })
                    );
                } else {
                    ordenes_temp = ordenes_temp.concat(this.extra);
                }
            }

            if (this.creado) {
                ordenes_temp.push(this.creado);
            }
            return ordenes_temp;
        },
    },
};
</script>
